import React from 'react';

import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { getInitialLoadIcons } from 'src/styles/font';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

interface ChevronRightIconProps {
  className: any;
  onClick?: (e: any) => void;
}
const iconStyle = css`
  color: ${colors.white};
  ${getInitialLoadIcons(InitialLoadIconsSet.CHEVRON)};
  &::before {
    display: block;
    font-size: 2.8rem;
    transform: rotate(-90deg);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  onClick,
  className
}) => {
  return (
    <button
      css={className}
      className={'arrow-btn'}
      aria-label="right chevron"
      onClick={onClick}>
      <span css={iconStyle}></span>
    </button>
  );
};

export default ChevronRightIcon;
